document.addEventListener("DOMContentLoaded", function () {
    if(document.querySelector('.sizes__tabs') !== null){
        let sizesTabs = document.querySelectorAll('.sizes__tabs');
        sizesTabs.forEach(function (item) {
            item.addEventListener('click', function (e){
                if(e.target.classList.contains('inches')){
                    item.querySelector('.inches').classList.add('active');
                    item.querySelector('.centimeters').classList.remove('active');
                    let numbers = item.closest('.sizes__group').querySelectorAll('.sizes__panels tbody tr td ~ td');
                    numbers.forEach(function (elem) {
                        // if(elem.textContent != ''){
                        //     if(elem.textContent.includes('-') ){
                        //         let number = elem.textContent.split(' - ');
                        //         elem.textContent = ((number[0] / 0.3937007874).toFixed(1)) + ' - ' + ((number[1] / 0.3937007874).toFixed(1));
                        //     }else{
                        //         elem.textContent = (elem.textContent / 0.3937007874).toFixed(1);
                        //     }
                        // }
                        elem.textContent = elem.dataset.col;
                    })
                }else if(e.target.classList.contains('centimeters') && !e.target.classList.contains('active')){
                    item.querySelector('.inches').classList.remove('active');
                    item.querySelector('.centimeters').classList.add('active');
                    let numbers = item.closest('.sizes__group').querySelectorAll('.sizes__panels tbody tr td ~ td');
                    numbers.forEach(function (elem) {
                        if(elem.textContent != '') {
                            if(elem.textContent.includes('-') ) {
                                let number = elem.textContent.split(' - ');
                                elem.textContent = ((number[0] * 0.3937007874).toFixed(1)) + ' - ' + ((number[1] * 0.3937007874).toFixed(1));
                            }else {
                                elem.textContent = (elem.textContent * 0.3937007874).toFixed(1);
                            }
                        }
                    })
                }
            })
        })
    }
});
